import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Nacija } from './nacija';

@Component({
  selector: 'yt-nacija',
  templateUrl: './nacija.component.html'
})
export class NacijaComponent extends BaseModalContainer<Nacija> implements OnInit {
  constructor(
    protected modalContainerService: ModalContainerService<Nacija>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
